module.exports = __webpack_public_path__ + "img/hk.267c338f.svg";